
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tour]/[[...scene]]",
      function () {
        return require("private-next-pages/[tour]/[[...scene]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tour]/[[...scene]]"])
      });
    }
  